import React, { Component } from 'react';
import SecurityQuestions from '../../FormElements/SecurityQuestions';

class FormSecurity extends Component {

    constructor(props) {
        super(props);
        this.formSecurity = React.createRef();
        this.password = React.createRef();
        this.password2 = React.createRef();
        this.question1 = React.createRef();
        this.question2 = React.createRef();
        this.answer1 = React.createRef();
        this.answer2 = React.createRef();
    }

    validate = () => {

        /* Check required fields */
        // const input_password = this.password.current;
        // const input_password2 = this.password2.current;
        const input_question1 = this.question1.current;
        const input_question2 = this.question2.current;
        const input_answer1 = this.answer1.current;
        const input_answer2 = this.answer2.current;

        /* Reset any previous custom validity settings to valid */
        // input_password.setCustomValidity('');
        // input_password2.setCustomValidity('');

        /* Make sure the password meets minimum requirements */
        // const validatePassword = /^(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{7,30}$/.test(input_password.value);

        // if (input_password.checkValidity() === false || input_password2.checkValidity() === false) {
        //     return false;
        // }
        // else if (this.props.values.password !== this.props.values.password2) {
        //     input_password2.setCustomValidity('Passwords do not match.');
        //     return false;
        // }
        // else if (!validatePassword && input_password.value.length < 8) {
        //     input_password.setCustomValidity('Your new password must be between 8 and 12 characters long and have letters, numbers and special characters.');
        //     return false;
        // }
        if (input_question1.checkValidity() === false || input_question2.checkValidity() === false || input_answer1.checkValidity() === false || input_answer2.checkValidity() === false) {
            return false;
        }
        else {
            return true;
        }
    }

    saveAndContinue = async (e) => {
        e.preventDefault()
        if (this.validate()) {
            let name = this.props.values.firstname + " " + this.props.values.lastname;
            await this.props.trackApplication(this.props.appData.appToken, this.props.values.email, 'Security', this.props.values.company, name, this.props.values.address_1, this.props.values.address_2, this.props.values.city, this.props.values.state, this.props.values.country, this.props.values.zipcode, this.props.values.phone, this.props.values.mobile, this.props.values.im_handle, this.props.values.experience_description, this.props.values.experience_level)
            this.props.nextStep();
        } else {
            /* Forces html5 form validation */
            const formSecurity = this.formSecurity.current;
            formSecurity.reportValidity();
        }
    }

    back = (e) => {
        e.preventDefault()
        this.props.prevStep();
    }

    render() {

        const { values } = this.props;

        return (
            <form ref={this.formSecurity}>
                {/* <div className="form-row mb-3 text-white"> */}
                    {/* <div className="col text-left">
                        <label htmlFor="Password">Password*</label>
                        <input
                            ref={this.password}
                            onChange={this.props.handleChange('password')}
                            placeholder="Password"
                            defaultValue={values.password}
                            className="form-control"
                            type="password" required />
                    </div>
                    <div className="col text-left">
                        <label htmlFor="Password">Re-Enter Password*</label>
                        <input
                            ref={this.password2}
                            onChange={this.props.handleChange('password2')}
                            placeholder="Re-Enter Password"
                            defaultValue={values.password2}
                            className="form-control"
                            type="password"
                            required />
                    </div>
                </div>
                <hr className="border-white"></hr> */}
                <div className="form-group mb-3 text-white text-left">
                    <label htmlFor="security_q1">Security Question 1*</label>
                    <select
                        ref={this.question1}
                        onChange={this.props.handleChange('security_q1')}
                        defaultValue={values.security_q1}
                        className="form-control"
                        required>
                        <option value=""></option>
                        <SecurityQuestions selectedValue={values.security_q1} questionGroup={1} />
                    </select>
                </div>
                <div className="form-group mb-3 text-white text-left">
                    <label htmlFor="security_a1">Answer*</label>
                    <input
                        ref={this.answer1}
                        onChange={this.props.handleChange('security_a1')}
                        placeholder="Answer"
                        defaultValue={values.security_a1}
                        className="form-control"
                        maxLength="20"
                        required />
                </div>
                <hr className="border-white"></hr>
                <div className="form-group mb-3 text-white text-left">
                    <label htmlFor="security_q2">Security Question 2*</label>
                    <select
                        ref={this.question2}
                        onChange={this.props.handleChange('security_q2')}
                        defaultValue={values.security_q2}
                        className="form-control"
                        required>
                        <option value=""></option>
                        <SecurityQuestions selectedValue={values.security_q2} questionGroup={2} />
                    </select>
                </div>
                <div className="form-group mb-3 text-white text-left">
                    <label htmlFor="security_a2">Answer*</label>
                    <input
                        ref={this.answer2}
                        onChange={this.props.handleChange('security_a2')}
                        placeholder="Answer"
                        defaultValue={values.security_a2}
                        className="form-control"
                        maxLength="20"
                        required />
                </div>
                <div className="d-flex flex-row-reverse">
                    <div className="pl-2 flex-1">
                        <button onClick={this.saveAndContinue} className="btn btn-lg btn-primary btn-block">Next</button>
                    </div>
                    <div className="flex-1">
                        <button onClick={this.back} className="btn btn-lg btn-secondary btn-block">Back</button>
                    </div>
                </div>
            </form>
        );
    }
}

export default FormSecurity;